import React, { useEffect } from "react";

import withSessionHandling from "@/context/auth/withSessionHandling";
import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type ContentScreenState } from "@/schemas/screen/configs";
import { ContentTabs, Screen } from "@/schemas/screen/tabs";
import ContentScreen from "@/screens/Content/Feed/ContentFeedScreen";

function Page(): React.JSX.Element {
  const { setCurrentScreen } = useHeaderContext();

  useEffect(() => {
    const defaultTab: ContentScreenState = {
      screenId: Screen.CONTENT,
      activeTabId: ContentTabs.EVENTS,
      filters: null,
    };
    setCurrentScreen(defaultTab);
  }, []);

  return <ContentScreen />;
}

export default withSessionHandling(Page);
